import React, { useState } from "react";

import { Upload } from "antd";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { InboxOutlined } from "@ant-design/icons";

import { URL } from "../../../../../../../service/api";
import axios from "axios";

const { Dragger } = Upload;

export function UploadDoc({
  setIsFiles,
  formulario,
  setFormulario,
  setIsRender,
  validaDateForm,
  formatErrorMessage,
  setIsvalidate,
  setIsFile,
  setIsFileName,
  setRetificacao,
  retificacaoFile,
}) {
  const props = {
    onRemove(file) {
      setIsFiles((prevFiles) =>
        prevFiles.filter((item) => item.uid !== file.uid)
      );
      //console.log(file)
    },
    name: "file",
    multiple: true,
    customRequest: async ({ file, onSuccess, onError }) => {
      var situacaoId = formulario.situacao;
      if (formulario.situacao == null || formulario.situacao == "") {
        situacaoId = "E";
        setFormulario((prevState) => ({
          ...prevState,
          situacao: situacaoId,
          motivo: "",
        }));
        setIsRender(true);
      }

      try {
        let dataComparar = null;
        const formData = new FormData();
        formData.append("file", file, file.name);
        //console.log(file.type); // Deve ser algo como "application/pdf"

        const response = await axios.post(
          `${URL}/obrigacao/arquivo/validate?obrigacaoId=${formulario.obrigacao}&clienteId=${formulario.clienteId}&situacaoId=${situacaoId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        let data = validaDateForm(response);
        let day = null;
        let month = null;
        let year = null;

        // Concatena o mês e o ano no formato desejado
        if (data != null) {
          [day, month, year] = data;
          dataComparar = `${month}/${year}`;
        }

        if (response.data.erro) {
          const errorMessage = formatErrorMessage(response.data.erro.mensagem);
          toast.error(`Erro: ${errorMessage}`, "Retire o arquivo do upload");
          onError(new Error(errorMessage));
          setIsvalidate(false);
        } else if (
          dataComparar != null &&
          response.status != 204 &&
          dayjs(formulario.mesRef).format("MM/YYYY") != dataComparar
        ) {
          toast.error(
            "A data de competencia da obrigação " +
              dayjs(formulario.mesRef).format("MM/YYYY") +
              " não corresponde a competência esperada " +
              dataComparar
          );
          setIsvalidate(false);
          onError(
            new Error(
              "A data de competencia da obrigação ",
              dayjs(formulario.mesRef).format("MM/YYYY"),
              " não corresponde a competência esperada",
              dataComparar
            )
          );
          return;
        } else {
          onSuccess(response.data, file);
          const newFile = { uid: file.uid, file: file, fileName: file.name };
          setIsFiles((prevFiles) => [...prevFiles, newFile]);
          setIsFile(file);
          setIsFileName(file.name);
          setRetificacao((prevState) => ({
            ...prevState,
            DATA_COMPETENCIA: response.data.DATA_COMPETENCIA,
            FORMATO_ARQUIVO: response.data.FORMATO_ARQUIVO,
            CNPJ: response.data.CNPJ,
            VALOR_GUIA: response.data.VALOR_GUIA,
            DATA_VENCIMENTO_GUIA: response.data.DATA_VENCIMENTO_GUIA,
          }));
          setIsvalidate(true);
          console.log(retificacaoFile);
        }
      } catch (error) {
        toast.error(`${file.name} falha ao enviar o arquivo.`);
        console.log("mostrar erro:", error);
        setIsvalidate(false);
      }
      // } catch (error) {
      //   toast.error(`${file.name} falha ao enviar o arquivo.`);
      //    setIsvalidate(false);
      // }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  return (
    <>
      <Dragger
        {...props}
        name="file"
        multiple={false}
        accept=".pdf"
        rules={[
          {
            required: true,
            message: "Por favor, anexe o documento!",
          },
        ]}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Clique ou arraste o arquivo para esta área para fazer upload.
        </p>
      </Dragger>
    </>
  );
}

export default UploadDoc;
